
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLivescoringRPR"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getLivescoringRPR"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"livescoring"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"wertung"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"eds_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"scoresPlayerTrySave"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"scoresPlayerSaved"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isSigned"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"player"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nameLong"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"teename"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"teegender"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"course"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"par"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"slope"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numHoles"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"scoringMode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"roundPlayerId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"teamPlayers"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rgba"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"marker"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nameLong"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rgba"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"pars"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"indexes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"gbe"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"scoresPlayer"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"scoresMarker"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"vorgabenPlayer"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"vorgabenMarker"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"signaturePlayer"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"signatureMarker"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":500}};
    doc.loc.source = {"body":"query getLivescoringRPR($id: Int!) {\n    getLivescoringRPR(input: { id: $id }) {\n        livescoring { id, name, wertung, eds_id, status, date, scoresPlayerTrySave, scoresPlayerSaved, isSigned,\n        player { nameLong, teename, teegender, course, par, cr, slope, numHoles, scoringMode, roundPlayerId, teamPlayers, rgba }, \n        marker { nameLong, rgba }, \n        pars, indexes, gbe, scoresPlayer, scoresMarker, vorgabenPlayer, vorgabenMarker, signaturePlayer, signatureMarker,\n        }\n    }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["getLivescoringRPR"] = oneQuery(doc, "getLivescoringRPR");
        
